<template>
  <div class="notifications-icon">
    <BellIcon aria-hidden="true" v-bind="$attrs" />
    <span class="notifications-icon__point" />
  </div>
</template>

<script setup lang="ts">
import { BellIcon } from '@heroicons/vue/24/outline'

type Props = {
  iconClass?: string
}

defineProps<Props>()

defineOptions({ inheritAttrs: false })
</script>

<style scoped>
.notifications-icon {
  @apply relative;

  &__point {
    @apply w-1.5 h-1.5;
    @apply absolute top-0 right-0;
    @apply rounded-full;
    @apply bg-red-500;
  }
}
</style>
